import { QueryClient, useQuery } from '@tanstack/vue-query';
import { onUnmounted } from 'vue';

import { getAboutLandingData } from '../api/aboutLanding.api';

export const useAboutLandingQuery = () => {
  const queryClient = new QueryClient();

  queryClient.mount();
  onUnmounted(() => {
    queryClient.unmount();
  });

  return useQuery(
    {
      queryKey: ['about-landing'],
      queryFn: getAboutLandingData,
    },
    queryClient,
  );
};
